// @ts-nocheck
import React, { useCallback } from 'react';
import {
  Box,
  Dialog,
  Grid,
  IconButton,
  Typography,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../assets/Icons/lucideIcons/x.svg';
import PropTypes from 'prop-types';
import DialogTransition from '../Transition/DialogTransition';
import { NOOP } from '../../../const/CommonConst';

const DeleteModal = ({
  open = false,
  handleClose = NOOP,
  deleteConfirm = NOOP,
  alertLabelText = '',
  warningText = '',
  deleteConfirmText = 'Delete',
  resourceName = '',
  isWarning = false,
  loading = false,
  shouldAutoCloseOnConfirm = true,
}) => {
  const onClose = useCallback(() => {
    handleClose();
  }, [handleClose]);

  const onDelete = useCallback(() => {
    deleteConfirm();
    if (shouldAutoCloseOnConfirm) {
      handleClose();
    }
  }, [deleteConfirm, handleClose, shouldAutoCloseOnConfirm]);

  const getDialogTitle = () => {
    if (!resourceName) {
      return '';
    }

    const prefix = !isWarning ? deleteConfirmText : '';
    return `${prefix} ${resourceName}`.trim();
  };

  return (
    <Box>
      <Dialog
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        slots={{
          transition: DialogTransition,
        }}
      >
        <DialogTitle>
          <Box component="span" aria-live="polite" aria-atomic="true">
            {getDialogTitle()}
          </Box>
        </DialogTitle>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          onClick={onClose}
          disabled={loading}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {warningText && (
              <Grid size={12}>
                <Typography
                  variant="body4"
                  role="note"
                  aria-label={`Important note: ${warningText}`}
                >
                  <strong>Note:</strong>&nbsp;
                  <i>{warningText}</i>
                </Typography>
              </Grid>
            )}
            <Grid size={12}>
              <Typography
                variant="body1"
                align="center"
                role="note"
                aria-label={alertLabelText}
              >
                {alertLabelText}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              title="Cancel"
              onClick={onClose}
              size="small"
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              onClick={onDelete}
              variant="outlined"
              title={deleteConfirmText}
              size="small"
              color="error"
              disabled={loading}
            >
              {loading ? 'Deleting...' : deleteConfirmText}
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

DeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  deleteConfirm: PropTypes.func.isRequired,
  alertLabelText: PropTypes.string.isRequired,
  warningText: PropTypes.string.isRequired,
  deleteConfirmText: PropTypes.string,
  resourceName: PropTypes.string.isRequired,
  isWarning: PropTypes.bool,
  loading: PropTypes.bool,
  shouldAutoCloseOnConfirm: PropTypes.bool,
};

export default React.memo(DeleteModal);
